<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="directoryListTitle" width="600px" @close="closePopup">
    <el-form slot="content" :model="detectInfo" :rules="rules" label-position="top" :ref="formName">
      <el-row>
        <el-col :span="24">
          <el-form-item label="디렉토리명" prop="path">
            <el-input :disabled="isDelete" v-model="detectInfo.path" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="감시 크기 설정 (MB)" prop="detectFileSize">
            <el-input-number v-model="detectInfo.detectFileSize" controls-position="right" :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
        * 감시 크기 설정(MB) 이란?<br>
        <br>
        감지되는 파일 크기의 기준을 지정합니다.<br>
        설정된 디렉토리에 생성되는 파일의 크기가 감시 크기 설정보다 클 경우 이력에 저장됩니다.<br>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" size="large" type="solid" @click="saveDetectFile">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, isUndefined, isEmpty, clone } from 'lodash';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';

const DEFAULT_DETECT = {
  path: null,
  detectFileSize: 0,
};
export default {
  name: 'WBulkDetectPopup',
  props: {
    popupType: String,
    editRow: Object,
    selectPhysicalNode: Object,
  },
  data() {
    return {
      isDelete: false,
      formName: 'detectInfoForm',
      directoryListTitle: '감시 디렉토리 추가',
      detectInfo: {
        path: null,
        detectFileSize: 0,
      },
      rules: {
        path: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validatePath,
          },
        ],
        detectFileSize: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
      },
    };
  },
  watch: {
    editRow: {
      handler(row) {
        if (isEmpty(row)) {
          this.detectInfo = DEFAULT_DETECT;
        } else {
          this.detectInfo = clone(row);
        }

        if (this.popupType === 'ADD') {
          this.isDelete = false;
          this.directoryListTitle = `[${this.selectPhysicalNode.label}] 감시 디렉토리 추가`;
        } else {
          this.isDelete = true;
          this.directoryListTitle = `[${this.selectPhysicalNode.label}] 감시 디렉토리 정보 수정`;
        }
      },
      deep: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    /**
     * [saveDetectFile 서버 설정 > 파일 감시 > 대용량 파일 생성 감시 목록을 추가 또는 수정한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    saveDetectFile() {
      const me = this;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const target = '감시 디렉토리';
          if (this.popupType === 'ADD') {
            // 추가 팝업으로 띄워진 경우
            const savaParams = clone(this.detectInfo);
            // 디렉토리 추가인 경우이기 때문에 isDirectory='Y'
            savaParams.serverId = this.selectPhysicalNode.serverId;
            savaParams.isDirectory = 'Y';
            const action = msgUtil.action.ADD;
            ServerSettingAPI.insertBulkFileDetectDir(savaParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            // 편집 팝업으로 띄워진 경우
            const savaParams = clone(this.detectInfo);
            // PK가 일치하는 항목에 대해서 detectFileSize만 수정할 수 있도록 쿼리 작성됌
            savaParams.serverId = this.selectPhysicalNode.serverId;
            savaParams.fileID = me.editRow.fileId;
            savaParams.pathHash = me.editRow.pathHash;
            const action = msgUtil.action.SAVE;
            ServerSettingAPI.updateBulkFileDetectDir(savaParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      });
    },
    validatePath(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error('필수 정보입니다.'));
      } else if (this.popupType === 'ADD') {
        const params = {
          serverId: this.selectPhysicalNode.serverId,
          path: this.detectInfo.path,
          isDirectory: 'Y',
        };
        ServerSettingAPI.checkExistDetectFile(params).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              callback(new Error('이미 존재하는 감시 디렉토리입니다.'));
            } else {
              callback();
            }
          } else {
            callback(new Error('중복 여부를 확인하지 못하였습니다.'));
          }
        }).catch(() => {
          callback(new Error('중복 여부를 확인하지 못하였습니다.'));
        });
      } else {
        callback();
      }
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/BulkFileCreateView/popup/BulkDetectPopup.vue